import { FC } from 'react';
import { cn } from '@/helpers/cn';
import { CardData } from '@/components/containers/types';
import { dynamicClientRouteMaker } from '@/helpers/routes/dynamicClientRouteMaker';
import useAuth from '@/context/auth/useAuth';
import { useRouter } from 'next/navigation';

type SearchResultContestCardPropsType = {
    cardData: CardData;
    className?: string;
};

const SearchResultContestCard: FC<SearchResultContestCardPropsType> = ({
                                                                           cardData,
                                                                           className
                                                                       }) => {
    const router = useRouter();
    const { userIsLoggedIn, setInAppLoginModalIsOpen } = useAuth();

    const handleCardClick = () => {
        const toGoUrl = dynamicClientRouteMaker({
            id: cardData.related_link?.obj_id,
            type: cardData.data_type,
            urlAlias: cardData.related_link?.url_alias,
            moreData: { matchId: cardData.match }
        });

        if (userIsLoggedIn) {
            router.push(toGoUrl);
        } else {
            setInAppLoginModalIsOpen({
                isOpen: true,
                toGoUrl,
                previousUrl: null
            });
        }
    };

    return (
        <div
            onClick={handleCardClick}
            className={cn('flex w-full gap-2', className)}>
            <img
                className="w-[31%] rounded-lg shrink-0 aspect-[207/100] object-cover"
                src={cardData.posters?.horizontal_poster}
                alt={cardData.title}
            />
            <div className="flex flex-col">
                <h4 className="font-semibold text-base mb-2">{cardData.title}</h4>
                {/*<p className="text-neutral-600 mt-1">*/}
                {/*    {`${dateCreated} ${dict.search.daysAgoAdded}`}*/}
                {/*</p>*/}
            </div>
        </div>
    );
};

export default SearchResultContestCard;